import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mock';
import { Logo } from './Logo';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {/* Company Info */}
          <div className="text-right">
            <div className="mb-4">
              <Logo size="medium" showText={true} />
            </div>
            <p className="text-gray-400 leading-relaxed">
              {companyInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-right">
            <h4 className="text-lg font-bold mb-4">روابط سريعة</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  الرئيسية
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  من نحن
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('brands')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  أنواع السيارات
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  اتصل بنا
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-right">
            <h4 className="text-lg font-bold mb-4">معلومات الاتصال</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 justify-end">
                <a
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="text-gray-400 hover:text-white transition-colors" dir="ltr"
                >
                  {companyInfo.phone}
                </a>
                <Phone className="h-5 w-5 text-blue-400" />
              </li>
              <li className="flex items-center gap-2 justify-end">
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-white transition-colors break-all"
                >
                  {companyInfo.email}
                </a>
                <Mail className="h-5 w-5 text-blue-400" />
              </li>
              <li className="flex items-center gap-2 justify-end">
                <span className="text-gray-400">{companyInfo.address}</span>
                <MapPin className="h-5 w-5 text-blue-400" />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="text-center text-gray-400">
            <p>
              &copy; {new Date().getFullYear()} {companyInfo.name}. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};